export const useTenantFetch  = async <T = unknown>(url: string, options: any = {}) => {
  const isServer = import.meta.server;
  const nuxtApp = useNuxtApp();
  const { ssrContext } = nuxtApp;
  //const config: any = nuxtApp.$publicEnv;
  const settings = useGeneralStore();
  const apiUrl = settings.getAppEndpoint(url);
  const {public: configP} = useRuntimeConfig();

  const { async = false, ...fetchOptions } = options;

  const data = ref<T | null>(null);
  const pending = ref(false);
  const error = ref<Error | null>(null);

  if (!configP.useFetch || async || !ssrContext ) {
    try {
      pending.value = true;
      //if(fetchOptions.query && !fetchOptions.method) fetchOptions.method = 'POST';
      data.value = await $fetch<T>(apiUrl, {
        //baseURL: config.apiBaseUrl,
        ...fetchOptions,
      });
    } catch (err) {
      error.value = err as Error;
    } finally {
      pending.value = false;
    }

    return {
      data,
      pending,
      error,
      refresh: async () => {
        try {
          pending.value = true;
          data.value = await $fetch<T>(apiUrl, fetchOptions);
        } catch (err) {
          error.value = err as Error;
        } finally {
          pending.value = false;
        }
      },
    };
  }
  
  const { data: fetchData, pending: fetchPending, error: fetchError, refresh } = await useFetch<T>(apiUrl, {
    //baseURL: config.apiBaseUrl,
    ...fetchOptions,
    server: isServer,
  });

  return {
    data: fetchData,
    pending: fetchPending,
    error: fetchError,
    refresh,
  };
}
